<template>
  <div class="insurance-variants-section">
      <ul class="insurance-variants-section__cards">
        <li
          class="insurance-variants-section__item"
          v-for="(card, idx) in cards"
          :key="idx"
        >
          <InsuranceTariffCard
            class="insurance-variants-section__item-card"
            :tariff="card.tariff"
            :title="card.title"
            :subtitle="card.subtitle"
            :price="card.price"
            :list-items="card.listItems"
            :is-selected="card.isSelected"
            :submitText="card.isSelected ? 'Выбрано' : 'Выбрать'"
            @tariff-chosen="handleTariff"
          />
        </li>
      </ul>
  </div>
</template>

<script>
import { INSURANCE_CARDS } from '@/consts';
import { commafy } from '@/utils/string-helpers';
import { calculatorEipoteka } from "@/api/routes/calculator-eipoteka";
import InsuranceTariffCard from '@/components/ui/InsuranceTariffCard';

export default {
  name: 'TheInsuranceVariants',
  components: {
    InsuranceTariffCard,
  },
  props: {
    tariffsSum: Object,
    formData: Object,
  },
  data() {
    return {
      cards: null,
    }
  },
  computed: {
  },
  methods: {
    handleTariff(tariff, isSelected) {
      this.cards = this.cards.map((card) => ({
        ...card,
        isSelected: (tariff === card.tariff) ? isSelected : card.isSelected,
      }));

      this.$emit('tariff-chosen', this.cards)
    },
  },
  async mounted() {
    this.sessionData = await calculatorEipoteka('getSessionData');

    this.cards = INSURANCE_CARDS;

    if (this.sessionData && this.sessionData.stepTwo && this.sessionData.stepTwo.tariffs) {
      this.cards = this.cards.map((card) => ({
        ...card,
        isSelected: this.sessionData.stepTwo.tariffs[card.tariff],
      }));
    }

    this.cards = this.cards.filter((card) => {
        return card.tariff === 'property' && this.tariffsSum.sumPremProperty
          || card.tariff === 'life' && this.tariffsSum.sumPremLife;
    });

    const { sumPremProperty, sumPremLife } = this.tariffsSum

    this.cards.map((card) => {
      card.price = commafy(this.formData.credit_balance);

      if (card.tariff === 'property' && sumPremProperty) {
        card.sumPrem = sumPremProperty;
        card.listItems[0].price = sumPremProperty;
      }

      if (card.tariff === 'life' && sumPremLife) {
        card.sumPrem = sumPremLife;
        card.listItems[0].price = sumPremLife;
      }
    });

    if (this.cards.length === 1) {
      this.cards = this.cards.map((card) => {
        return {
          ...card,
          isSelected: true,
        }
      })
    }

    this.$emit('mounted', this.cards);
  },
}
</script>

<style scoped lang="scss">
.insurance-variants-section {
  &__cards {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media #{$screen-big} {
      flex-direction: row;
    }

    @media #{$screen-small} {
      flex-direction: column;
    }
  }

  &__item {
    @media #{$screen-big} {
      @include flex-width-two-in-row(24px);
    }

    @media #{$screen-small} {
      width: auto;
    }

    &:not(:last-child) {
      margin-bottom: rem(24);

      @media #{$screen-big} {
        margin-bottom: 0;
      }

      @media #{$screen-small} {
        margin-bottom: rem(24);
      }
    }

    &-card {
      height: 100%;
    }
  }
}
</style>
